import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row mb-3" }
const _hoisted_5 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_6 = { class: "col-md-6 d-flex justify-content-end align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_8 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "me-2" }, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users.per_page,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "me-2",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.users.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
              class: "form-control me-2",
              placeholder: "Chercher",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter())),
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          responsive: ""
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [6]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                ]))
              : (props.column.field === 'for_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (props.row.magasin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.row.magasin.market_name), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" (" + _toDisplayString(props.row.for_name) + ") ", 1)
                  ]))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      (props.row.created_at != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                        : _createCommentVNode("", true),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                    ]))
                  : (props.column.field === 'validate_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        (props.row.validate_time != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getDate(props.row.validate_time)), 1))
                          : _createCommentVNode("", true),
                        (props.row.duration_days && props.row.duration_days != '')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.numberPars(props.row.duration_days)) + " jours ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field === 'reçu')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          (props.row.reçu == 2)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_15, "1"))
                            : (_openBlock(), _createElementBlock("h5", _hoisted_16, "0"))
                        ]))
                      : (props.column.field === 'statut')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (props.row.statut == 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                }, " Nouveau ", 2))
                              : (props.row.statut == 1)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                  }, " En attenete d'expédition ", 2))
                                : (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                    }, " Expédier vers client ", 2))
                                  : (props.row.statut == 3)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 3,
                                        class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.statut
                )}`, "text-capitalize"])
                                      }, " Reçu par client ", 2))
                                    : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 6,
                              class: "dropdown-item",
                              href: "#",
                              onClick: ($event: any) => (_ctx.GetPDF(props.row))
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "flaticon-download me-1" }, null, -1),
                              _createTextVNode(" Télécharger ", -1)
                            ]), 8, _hoisted_17))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ]))
}